import { API } from 'config';
import { AC_ACTIVITY_LOG_LIST_PARAMS } from 'models/activity-logs';
import { AppAPIInstance } from 'services/config-api';

export const getActivityLogsApi = async (
  params?: AC_ACTIVITY_LOG_LIST_PARAMS
) => {
  return await AppAPIInstance.get(API.CONCIERGE.ACTIVITY_LOGS, {
    params,
  });
};
